/**
 * Icon Utilities
 * Helper functions for dynamically rendering lucide-react icons
 */
import * as LucideIcons from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

/**
 * Get a lucide-react icon component by name
 * @param iconName - The name of the icon (e.g., "Building", "MapPin")
 * @returns The icon component or null if not found
 */
export function getIconComponent(iconName: string | null | undefined) {
  if (!iconName) return null;

  const IconComponent = (LucideIcons as unknown as Record<string, LucideIcon>)[iconName];
  // Lucide icons are ForwardRef components (objects with render function), not plain functions
  if (IconComponent && (typeof IconComponent === 'function' || typeof (IconComponent as { render?: unknown }).render === 'function')) {
    return IconComponent;
  }

  return null;
}

